let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("k3mTs")).then(() => parcelRequire('d55ia'));